export default {"src":"/_next/static/media/ntbc.985c0e05.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};